<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-03-06 10:09:38
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-03-06 10:09:51
 * @FilePath: /seller.sviptrader.com/src/views/configure/components/cancelDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-dialog title="确认取消规则编辑？" :visible.sync="dialogVisible" width="320px" :before-close="handleClose">
    <div class="yx-color-text-primary">取消规则编辑将不会保存已编辑的规则</div>
    <span slot="footer">
      <el-button @click="cancel">否</el-button>
      <el-button type="primary" @click="save">是</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'cancelDialog',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    cancel() {
      this.handleClose()
    },
    save() {
      this.$emit('back')
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped></style>
